// extracted by mini-css-extract-plugin
export default {"dialogPaper":"styles_dialogPaper__-LI3y"};